module.exports = __webpack_public_path__ + "static/media/server_2.1e2e0f84.png";